import React, { useEffect } from "react";
import { useLoader } from "../context/LoaderContext";

const Booking = () => {
  const { setLoading } = useLoader();
  useEffect(() => {
    setTimeout(() => setLoading(false), 200);
  }, [setLoading]);
  return (
    <>
      <div id="be-booking-form"></div>
    </>
  );
};

export default Booking;
